import * as React from 'react';
const SvgRightArrowPurple = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 18, height: 21, fill: "none" }, props),
    React.createElement("path", { fill: "#6e00a5", d: "M18 10.5.75 20.46V.54L18 10.5Z" })));
export default SvgRightArrowPurple;
